import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BarcodeScannerLivestreamModule } from 'ngx-barcode-scanner';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgxScannerQrcodeModule, LOAD_WASM } from 'ngx-scanner-qrcode';

import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule, SideNavInnerToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, LoginFormModule } from './shared/components';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { UnauthenticatedContentModule } from './unauthenticated-content';
import { AppRoutingModule } from './app-routing.module';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';


//devextreme
import { DxHttpModule } from 'devextreme-angular/http';
import { DxButtonModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { DxTextBoxModule } from 'devextreme-angular';
import { DxCheckBoxModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { DxPopupModule } from 'devextreme-angular';
import { DxRadioGroupModule } from 'devextreme-angular';
import { DxHtmlEditorModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { DxFileUploaderModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxDateBoxModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular';
import { DxListModule} from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxAccordionModule } from 'devextreme-angular';
import {DxDropDownBoxModule} from 'devextreme-angular';

//Synchfunction
import { SignatureModule } from '@syncfusion/ej2-angular-inputs';


//Komponentes
import { SubHeaderComponent } from './shared/components/sub-header/sub-header.component';
import { VoucherComponent } from './pages/voucher/voucher/voucher.component';
import { PickCarComponent } from './pages/voucher/pick-car/pick-car.component';
import { RuleCheckComponent } from './pages/voucher/rule-check/rule-check.component';
import { PickClientComponent } from './pages/voucher/pick-client/pick-client.component';
import { PickRegionComponent } from './pages/voucher/pick-region/pick-region.component';
import { PickRouteComponent } from './pages/voucher/pick-route/pick-route.component';
import { ChecklistComponent } from './pages/voucher/checklist/checklist.component';
import { InputOdometerComponent } from './pages/voucher/input-odometer/input-odometer.component';
import { FinishVoucherComponent } from './pages/voucher/finish-voucher/finish-voucher.component';
import { FuelPurchaseComponent } from './pages/common/fuel-purchase/fuel-purchase.component';
import { ServicePointManagerComponent } from './pages/dio/service-point-manager/service-point-manager.component';
import { NewVisitServicePointComponent } from './pages/dio/new-visit-service-point/new-visit-service-point.component';
import { VisitedServicePointComponent } from './pages/dio/visited-service-point/visited-service-point.component';
import { AdBluePurchaseComponent } from './pages/common/ad-blue-purchase/ad-blue-purchase.component';
import { CarWashPurchaseComponent } from './pages/common/car-wash-purchase/car-wash-purchase.component';
import { CommentComponent } from './pages/common/comment/comment.component';
import { AlcometerValueComponent } from './pages/common/alcometer-value/alcometer-value.component';
import { VisualDamagePickTypeComponent } from './pages/visual-damage/visual-damage-pick-type/visual-damage-pick-type.component';
import { VisualDamageActionPickComponent } from './pages/visual-damage/visual-damage-action-pick/visual-damage-action-pick.component';
import { VisualDamageDeffectPositionPickComponent } from './pages/visual-damage/visual-damage-deffect-position-pick/visual-damage-deffect-position-pick.component';
import { VisualDamagePostDamageComponent } from './pages/visual-damage/visual-damage-post-damage/visual-damage-post-damage.component';
import { MessagesComponent } from './pages/user/messages/messages.component';
import { WavesComponent } from './pages/common/waves/waves.component';
import { ServiceVoucherComponent } from './pages/service/service-voucher/service-voucher.component';
import { ServicePickCarComponent } from './pages/service/service-pick-car/service-pick-car.component';
import { ServiceVoucherStartAddCommentsComponent } from './pages/service/service-voucher-start-add-comments/service-voucher-start-add-comments.component';
import { ServiceVoucherStartPickServiceComponent } from './pages/service/service-voucher-start-pick-service/service-voucher-start-pick-service.component';
import { ServiceVoucherStartOdometerComponent } from './pages/service/service-voucher-start-odometer/service-voucher-start-odometer.component';
import { ServiceManageCarFaultsComponent } from './pages/service/service-manage-car-faults/service-manage-car-faults.component';
import { ServiceVoucherFinishComponent } from './pages/service/service-voucher-finish/service-voucher-finish.component';
import { ContactsComponent } from './pages/user/contacts/contacts.component';

//Services
import { AuthInterceptor } from './shared/services/auth-interceptor.service';
import { ConfigService } from './shared/services/config.service';
import { ActiveUserLocalDataService } from './shared/services/active-user-local-data.service';

//license un config
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';
import { StopsComponent } from './pages/common/stops/stops.component';
import dxLoadIndicator from 'devextreme/ui/load_indicator';
import { PickTrailerComponent } from './pages/voucher/pick-trailer/pick-trailer.component';

config({
  licenseKey
});

export function initializeApp(configService: ConfigService): () => Promise<void> {
  return () => configService.loadConfig();
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function initializeWasm(): () => Promise<void> {
  return () => LOAD_WASM().toPromise();
}


@NgModule({
  declarations: [
    AppComponent,
    SubHeaderComponent,
    VoucherComponent,
    PickCarComponent,
    RuleCheckComponent,
    PickClientComponent,
    PickRegionComponent,
    PickRouteComponent,
    ChecklistComponent,
    InputOdometerComponent,
    FinishVoucherComponent,
    FuelPurchaseComponent,
    ServicePointManagerComponent,
    NewVisitServicePointComponent,
    VisitedServicePointComponent,
    AdBluePurchaseComponent,
    CarWashPurchaseComponent,
    CommentComponent,
    AlcometerValueComponent,
    VisualDamagePickTypeComponent,
    VisualDamageActionPickComponent,
    VisualDamageDeffectPositionPickComponent,
    VisualDamagePostDamageComponent,
    MessagesComponent,
    WavesComponent,
    ServiceVoucherComponent,
    ServicePickCarComponent,
    ServiceVoucherStartAddCommentsComponent,
    ServiceVoucherStartPickServiceComponent,
    ServiceVoucherStartOdometerComponent,
    ServiceManageCarFaultsComponent,
    ServiceVoucherFinishComponent,
    ContactsComponent,
    StopsComponent,
    PickTrailerComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot([]),
    DxHttpModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    LoginFormModule,
    UnauthenticatedContentModule,
    AppRoutingModule,
    DxButtonModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    FormsModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxHtmlEditorModule,
    DxFormModule,
    DxFileUploaderModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxTabPanelModule,
    BarcodeScannerLivestreamModule,
    DxListModule,
    ZXingScannerModule,
    NgxScannerQrcodeModule,
    DxDataGridModule,
    AngularSignaturePadModule,
    DxAccordionModule,
    DxDropDownBoxModule,
    SignatureModule,
    DxLoadIndicatorModule
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthService,
    ScreenService,
    AppInfoService,
    ActiveUserLocalDataService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
